/** แปลง datetime เป็น yyyy-MM-dd ตามปฏิทินท้องถิ่น (สำหรับ input type="date") */
export function toLocalDateInput(value: string | Date | null | undefined): string {
  if (value == null || value === '') return '';
  if (typeof value === 'string') {
    const dateOnly = value.match(/^(\d{4}-\d{2}-\d{2})/);
    if (dateOnly && value.length <= 10) return dateOnly[1];
  }
  const d = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function localTodayDateInput(): string {
  return toLocalDateInput(new Date());
}

export function localDatePlusYearsInput(years: number): string {
  const d = new Date();
  d.setFullYear(d.getFullYear() + years);
  return toLocalDateInput(d);
}

export function addDaysToDateInput(value: string, days: number): string {
  const dateOnly = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!dateOnly) return value;
  const d = new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]));
  if (Number.isNaN(d.getTime())) return value;
  d.setDate(d.getDate() + days);
  return toLocalDateInput(d);
}

export function isDateRangeValid(startDate: string | null | undefined, endDate: string | null | undefined): boolean {
  if (!startDate || !endDate) return false;
  return startDate <= endDate;
}
